
const RESIZE = {
    titleService: `Resize image`,
    uploadBtn: `Upload Image`,
    dragAndDrop: `Drag & drop image here or`,
    dragAndDropRelease: `Release to upload the image`,
    notValidFomat: 'Invalid image format (only JPG / PNG files are supported)',
    notSizeValid: 'Your image dimensions are invalid. <br/> Image width and height must be less than 12000px.'
};

const ROTATE = {
    titleService: `Rotate image`,
    uploadBtn: `Upload Image`,
    dragAndDrop: `Drag & drop image here or`,
    dragAndDropRelease: `Release to upload the image`,
    notValidFomat: 'Invalid image format (only JPG / PNG files are supported)',
    notSizeValid: 'Your image dimensions are invalid. <br/> Image width and height must be less than 12000px.'
};

const FLIP = {
    titleService: `Flip image`,
    uploadBtn: `Upload Image`,
    dragAndDrop: `Drag & drop image here or`,
    dragAndDropRelease: `Release to upload the image`,
    notValidFomat: 'Invalid image format (only JPG / PNG files are supported)',
    notSizeValid: 'Your image dimensions are invalid. <br/> Image width and height must be less than 12000px.'
};

const CROPPER = {
    titleService: `Crop Image`,
    uploadBtn: `Upload Image`,
    dragAndDrop: `Drag & drop image here or`,
    dragAndDropRelease: `Release to upload the image`,
    notValidFomat: 'Invalid image format (only JPG / PNG files are supported)',
    notSizeValid: 'Your image dimensions are invalid. <br/> Image width and height must be less than 12000px.'
};


export default function getContantPage(service: string): {titleService: string, uploadBtn: string, dragAndDrop: string, dragAndDropRelease: string, notValidFomat: string, notSizeValid: string} {
    switch (service) {
        case 'rotator':
            return ROTATE;
        case 'resizer':
            return RESIZE;
        case 'flipper':
            return FLIP;
        case 'cropper':
            return CROPPER;
        default:
            return {
                titleService: `Resize image`,
                uploadBtn: `Upload Image`,
                dragAndDrop: `Drag & drop image here or`,
                dragAndDropRelease: `Release to upload the image`,
                notValidFomat: 'Invalid image format (only JPG / PNG files are supported)',
                notSizeValid: `Your image dimensions are invalid. <br/> 
                    Image width and height must be less than 12000px.`
            };
    }

}
